import { createAction } from 'redux-actions';
import * as C from '../constants';
import { fetchAPI } from '../utils/api';

export const setNewsFeedResponse = createAction(
  C.ACTION_TYPES.NEWS_FEED_SET_RESPONSE,
  (newsFeedResponse: PaginationResp<NewsFeedItem>) => ({ newsFeedResponse })
);

export const setSelectedNewsFeed = createAction(
  C.ACTION_TYPES.NEWS_FEED_SELECTED,
  (newsFeed: NewsFeedViewItem | null) => ({ newsFeed })
);

export const setSearchNewsFeedKeyword = createAction(
  C.ACTION_TYPES.NEWS_FEED_SET_SEARCH_KEY_WORDS,
  (searchKey: string) => ({ searchKey })
);

export const clearNewsFeedItems = createAction(
  C.ACTION_TYPES.NEWS_FEED_CLEAR_ITEMS
);

export const searchNewsFeed = searchKey => async (dispatch, getState) => {
  try {
    const res = await fetchAPI('/newsfeed/latest', {
      method: 'GET',
      payload: {
        q: searchKey,
        to_ts: Math.floor(Date.now() / 1000),
      },
    });
    dispatch(clearNewsFeedItems());
    const json: PaginationResp<NewsFeedItem> = await res.json();
    dispatch(setNewsFeedResponse(json));
  } catch (e) {}
};

export const fetchNewsFeed = (to_ts: number) => async (dispatch, getState) => {
  const res = await fetchAPI('/newsfeed/latest', {
    method: 'GET',
    payload: {
      to_ts,
    },
  });
  const json: PaginationResp<NewsFeedItem> = await res.json();
  dispatch(setNewsFeedResponse(json));
};

export const setFollowChannelStatus = createAction(
  C.ACTION_TYPES.NEWS_FEED_SET_FOLLOW_STATUS,
  (channelID: number) => ({ channelID })
);



// WEBPACK FOOTER //
// ./app/actions/NewsFeedActionCreators.ts